import React, { useEffect, useRef } from "react";
import { Text, Button } from "components/common";

const EmailInputScreen = ({
  loading,
  errorMessage,
  titleText,
  handleSubmit = () => {},
  email,
  setEmail = () => {},
}) => {
  const style = {};
  const input = useRef();
  const focus = () => input.current.focus();
  // Focus the field on load
  useEffect(() => {
    focus();
    if (email) {
      setEmail(email);
    }
  }, []);

  const getTextSize = () => {
    if (email.length > 27) {
      return "text-lg";
    }
    if (email.length > 17) {
      return "text-xl";
    }
    return "text-2xl";
  };

  return (
    <>
      <Text title className="mb-4 text-xl">{titleText}</Text>
      <input
        type="text"
        placeholder="Enter your email"
        value={email}
        className={`w-full bg-transparent py-2 border-b-2 text-center border-gray-500 outline-none phone-input inline-block ${getTextSize()}`}
        style={style}
        onChange={(e) => setEmail(e.target.value || "")}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            handleSubmit();
          }
        }}
        ref={input}
        disabled={loading}
      />
      <div className="text-red-500 text-sm mt-2">{errorMessage}</div>
      <div>
        <Button
          type="button"
          className="mb-6 mt-5 text-xl btn-green px-16"
          disabled={loading}
          style={{
            backgroundColor: loading ? "gray" : "#26E3BA",
          }}
          onClick={handleSubmit}
          paddingHorizontal={64}
        >
          Submit
        </Button>
      </div>
    </>
  );
};

export default EmailInputScreen;